import { trackEvent } from '~/features/analytics/track-event';
import { FlashSaleBanner } from '~/features/promotions/components/flash-sale-banner';
import { FlashSalePromoCard } from '~/features/promotions/components/flash-sale-promo-card';
import {
  type SeptFlash48Variant,
  getSeptFlash48CheckoutHref,
  SEPT_FLASH_48_CTA_LABEL,
  SEPT_FLASH_48_VARIANTS,
} from '~/features/promotions/constants/sept-flash-48';

import type { PromoCampaignSurfaceRenderers } from '../types';

const SEPT_FLASH_48_ANALYTICS_LABEL = 'sept_flash_48_sale_clicked';
const SEPT_FLASH_48_CTA_COLOR = '#175CFF';

export const septFlash48CampaignSurfaces: PromoCampaignSurfaceRenderers<SeptFlash48Variant>['surfaces'] = {
  homepage: ({ resolved, promoCode, imagePriority }) => {
    const config = SEPT_FLASH_48_VARIANTS[resolved];
    return (
      <FlashSalePromoCard
        backgroundGradient={config.backgroundGradient}
        backgroundImageDesktop={config.homepagePatternDesktop}
        backgroundImageMobile={config.homepagePatternMobile}
        backgroundImageOpacity={config.patternOpacity}
        checkoutHref={getSeptFlash48CheckoutHref(resolved, promoCode)}
        ctaColor={SEPT_FLASH_48_CTA_COLOR}
        ctaLabel={SEPT_FLASH_48_CTA_LABEL}
        eyebrowColor={config.eyebrowColor}
        headline={config.headline}
        id={`sept-flash-48-${resolved}-title`}
        imagePriority={imagePriority}
        stampImageDesktop={config.homepageStampDesktop}
        stampImageMobile={config.homepageStampMobile}
        stampSizeDesktop={config.homepageStampSizeDesktop}
        stampSizeMobile={config.homepageStampSizeMobile}
        subtitle={config.subtitle}
        subtitleColor={config.subtitleColor}
        onClick={() =>
          trackEvent({
            type: 'click',
            name: 'Homepage CTA Clicked',
            label: SEPT_FLASH_48_ANALYTICS_LABEL,
          })
        }
      />
    );
  },
  catalog: ({ resolved, promoCode, imagePriority }) => {
    const config = SEPT_FLASH_48_VARIANTS[resolved];
    return (
      <FlashSaleBanner
        backgroundGradient={config.backgroundGradient}
        backgroundImageDesktop={config.catalogPatternDesktop}
        backgroundImageMobile={config.catalogPatternMobile}
        backgroundImageOpacity={config.patternOpacity}
        borderColor={config.borderColor}
        checkoutHref={getSeptFlash48CheckoutHref(resolved, promoCode)}
        ctaColor={SEPT_FLASH_48_CTA_COLOR}
        ctaLabel={SEPT_FLASH_48_CTA_LABEL}
        eyebrowColor={config.eyebrowColor}
        headline={config.catalogHeadline}
        imagePriority={imagePriority}
        subtitle={config.subtitle}
        subtitleColor={config.subtitleColor}
        onCtaClick={() =>
          trackEvent({
            type: 'click',
            name: 'Catalog Page CTA Clicked',
            label: SEPT_FLASH_48_ANALYTICS_LABEL,
          })
        }
      />
    );
  },
  experience: ({ resolved, promoCode }) => {
    const config = SEPT_FLASH_48_VARIANTS[resolved];

    return {
      id: `sept_flash_48_${resolved}`,
      promoVariant: 'flash_sale',
      eyebrow: 'FLASH SALE',
      title: config.headline,
      description: config.subtitle,
      ctaLabel: SEPT_FLASH_48_CTA_LABEL,
      flashSale: {
        backgroundGradient: config.backgroundGradient,
        backgroundImage: config.experiencePattern,
        backgroundImageObjectPosition: 'center',
        backgroundImageOpacity: config.patternOpacity,
        bodyColor: config.subtitleColor,
        eyebrowColor: config.eyebrowColor,
        stampImageDesktop: config.experienceStampDesktop,
        stampImageMobile: config.experienceStampMobile,
      },
      action: {
        type: 'link',
        href: getSeptFlash48CheckoutHref(resolved, promoCode),
      },
    };
  },
};
